import React from 'react';
import { Link } from 'react-router-dom';

const BackOfficeSection = () => {
  return (
    <section className="backoffice-section" id="back-office">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Back Offices para Abogados de Inmigración</h2>
          <p className="section-description">
            Servicio exclusivo para abogados de inmigración. Apoyamos su firma con procesos operativos y administrativos que liberan carga laboral y optimizan el tiempo.
          </p>
        </div>

        <div className="backoffice-content">
          <div className="backoffice-info">
            <h3>¿Qué incluye nuestro Back Office?</h3>

            <div className="services-list">
              <div className="service-item">
                <div className="service-content">
                  <h4>Operativo</h4>
                  <ul>
                    <li>Intakes</li>
                    <li>Llenado de formularios migratorios</li>
                    <li>Preparación de mociones y paquetes</li>
                    <li>Organización documental</li>
                    <li>Gestión de evidencias</li>
                    <li>Seguimiento de fechas importantes</li>
                  </ul>
                </div>
              </div>

              <div className="service-item">
                <div className="service-content">
                  <h4>Administrativo</h4>
                  <ul>
                    <li>Envío y firma de contratos</li>
                    <li>Envío de invoices</li>
                    <li>Envío de recibos de pago</li>
                    <li>Gestión interna por WhatsApp Business</li>
                    <li>Organización de carpetas y expedientes</li>
                  </ul>
                </div>
              </div>
            </div>

            <h3>Beneficios del Back Office</h3>
            <ul className="backoffice-benefits-list">
              <li>Ahorro de tiempo</li>
              <li>Atención personalizada</li>
              <li>Cero errores en formularios</li>
              <li>Documentación entregada lista para firma</li>
              <li>Acompañamiento completo en cada caso</li>
            </ul>
          </div>

          <div className="backoffice-cta">
            <div className="cta-card">
              <div className="cta-buttons">
                <Link to="/soporte" className="btn btn-primary">Solicitar información</Link>
                <a
                  className="btn btn-secondary"
                  href="https://wa.me/18049608133?text=Hola%2C+quisiera+informaci%C3%B3n+sobre+Back+Office+para+abogados+de+inmigraci%C3%B3n"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Hablar por WhatsApp
                </a>
                <a className="btn btn-secondary" href="mailto:info@gesops.com?subject=Cotizaci%C3%B3n%20Back%20Office%20GesOps">
                  Solicitar cotización por correo
                </a>
              </div>
            </div>

            <div className="backoffice-note">
              <p>
                <strong>Cortesía incluida: Plan Básico del Directorio</strong>
              </p>
              <p>Los abogados que contratan Back Offices reciben:</p>
              <ul>
                <li>Tarjeta simple en el directorio</li>
                <li>Visibilidad en un estado</li>
                <li>Sin perfil editable</li>
                <li>Activación manual por el administrador</li>
              </ul>
              <p>Esto es un beneficio NO público. No se muestra como un plan.</p>
            </div>

            <div className="backoffice-note">
              <p>
                <strong>Nota importante:</strong> Por el momento, este servicio está disponible únicamente para abogados de inmigración. Próximamente podría expandirse a otras áreas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BackOfficeSection;
